<section class="ip-filter-table-invoices" [class.open-filter]="isOpenFilter">
  <div class="ip-filter-table-invoices__movile-toggle">
    <ng-container *ngTemplateOutlet="buttonClean" />
    <ng-container *ngTemplateOutlet="buttonToggle" />
  </div>

  <form class="ip-filter-table-invoices__form" [formGroup]="form">
    <div class="ip-filter-table-invoices__form-container">
      <div class="ip-filter-table-invoices__form-container-input-date" *ngIf="withFiscalIdFilter">
        <ng-container *ngTemplateOutlet="inputFiscalId" />
      </div>
      <div class="ip-filter-table-invoices__form-container-input-select" *ngIf="!withoutBrokerFilter">
        <ng-container *ngTemplateOutlet="inputBroker" />
      </div>
      <div class="ip-filter-table-invoices__form-container-input-date">
        <ng-container *ngTemplateOutlet="selectStatus" />
      </div>
      <div class="ip-filter-table-invoices__form-container-input-date">
        <ng-container *ngTemplateOutlet="inputCreateDateFrom" />
      </div>

      <div class="ip-filter-table-invoices__form-container-input-date">
        <ng-container *ngTemplateOutlet="inputCreateDateTo" />
      </div>
      
      <div class="ip-filter-table-invoices__form-container-input-date" *ngIf="withLoadingFilters">
        <ng-container *ngTemplateOutlet="inputLoadingDateFrom" />
      </div>

      <div class="ip-filter-table-invoices__form-container-input-date" *ngIf="withLoadingFilters">
        <ng-container *ngTemplateOutlet="inputLoadingDateTo" />
      </div>

      <div class="ip-filter-table-invoices__form-container-buttons">
        <div class="ip-filter-table-invoices__form-container-button-clean">
          <ng-container *ngTemplateOutlet="buttonClean" />
        </div>

        <div class="ip-filter-table-invoices__form-container-button-cancel">
          <ng-container *ngTemplateOutlet="buttonCancel" />
        </div>

        <div class="ip-filter-table-invoices__form-container-button-search">
          <ng-container *ngTemplateOutlet="buttonSearch" />
        </div>
      </div>
    </div>
  </form>
</section>

<ng-template #inputCreateDateFrom>
  <app-ip-date-input
    [control]="createDateFrom"
    inputId="createDateFrom"
    (changed)="onStartDateChange()"
    [max]="maxDateStart"
    [label]="dateInitLabel | translate"
    #startDateInput
  ></app-ip-date-input>
</ng-template>

<ng-template #inputCreateDateTo>
  <app-ip-date-input
    [control]="createDateTo"
    inputId="createDateTo"
    (changed)="onFinishDateChange()"
    [min]="minDateEnd"
    [max]="maxDateEnd"
    [label]="dateEndLabel | translate"
    #dueDateInput
  ></app-ip-date-input>
</ng-template>

<ng-template #buttonSearch>
  <app-ip-button-modal
    typeBtn="action"
    (clicked)="onSubmit(); isOpenFilter = false"
    [matTooltip]="'IP.SETTLEMENTS.SALE-PAYMENT.FILTERS.SEARCH' | translate"
    [size]="isOpenFilter ? 'normal' : 'small'"
    [disabled]="!form.valid"
  >
    <img
      class="ip-filter-table-invoices__form-icon"
      src="assets/icons/search.svg"
    />
  </app-ip-button-modal>
</ng-template>

<ng-template #buttonToggle>
  <app-ip-button-modal
    typeBtn="action"
    (clicked)="toggleFilter()"
    [size]="'small'"
  >
    <img
      class="ip-filter-table-invoices__form-icon"
      src="assets/icons/filter2.svg"
    />
  </app-ip-button-modal>
</ng-template>

<ng-template #buttonCancel>
  <app-ip-button-modal
    typeBtn="cancel"
    (clicked)="toggleFilter()"
    [size]="'normal'"
    textCodeBtn="IP.TABLE.INVOICES.FILTER_CANCEL_BTN"
  >
  </app-ip-button-modal>
</ng-template>

<ng-template #buttonClean>
  <app-ip-button-modal
    typeBtn="clean"
    (clicked)="cleanFilter()"
    [size]="'small'"
    [disabled]="!form.valid"
  >
    <img
      class="ip-filter-table-invoices__form-icon"
      src="assets/icons/cleaning.svg"
    />
  </app-ip-button-modal>
</ng-template>

<ng-template #selectStatus>
  <app-ip-select-input
    [labelCode]="statusLabel"
    [options]="optionsStatus"
    [selectFirstOption]="selectFirstStatus"
    [isMultiple]="true"
    (selectEmitter)="onSelectStatus($event)"
    [disabled]="disabledSelectStatus"
    [reset]="reset"
    [formGroup]="form"
    controlName="status"
    [selectedOptions]="selectedStatusChange$"
  />
</ng-template>

<ng-template #inputLoadingDateFrom>
  <app-ip-date-input
    [control]="loadingDateFrom"
    inputId="loadingDateFrom"
    (changed)="onStartLoadingDateChange()"
    [max]="maxLoadingDateStart"
    [label]="dateLoadingInitLabel | translate"
    [withHour]="true"
    #startLoadingDateInput
  ></app-ip-date-input>
</ng-template>

<ng-template #inputLoadingDateTo>
  <app-ip-date-input
    [control]="loadingDateTo"
    inputId="loadingDateTo"
    (changed)="onFinishLoadingDateChange()"
    [min]="minLoadingDateEnd"
    [max]="maxLoadingDateEnd"
    [label]="dateLoadingEndLabel | translate"
    [withHour]="true"
    #endLoadingDateInput
  ></app-ip-date-input>
</ng-template>

<ng-template #inputBroker>
  <app-ip-broker-input-select
    [control]="brokerNameBussiness"
    (selectionChange)="selectBroker($event)"
  />
</ng-template>

<ng-template #inputFiscalId>
  <app-ip-input
    [control]="fiscalId"
    inputId="fiscalId"
    [label]="'IP.TABLE.INVOICES.FILTER_FISCALID' | translate"
  ></app-ip-input>
</ng-template>